import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CONTACT } from '../constants/contact';
import { SITE_URL, SITE_BRAND } from '../constants/site';

export function JsonLdOrganization() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    name: SITE_BRAND,
    alternateName: 'Thermo Cool System',
    image: `${SITE_URL}/logo.png`,
    url: SITE_URL,
    telephone: CONTACT.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Moravička 4',
      addressLocality: 'Kovačevac',
      addressRegion: 'Prijepolje',
      postalCode: '31304',
      addressCountry: 'RS',
    },
    areaServed: {
      '@type': 'Country',
      name: 'Srbija',
    },
    sameAs: [CONTACT.instagram],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
